import { render, staticRenderFns } from "./auth-jg.vue?vue&type=template&id=5e9121ae&scoped=true"
import script from "./auth-jg.vue?vue&type=script&lang=js"
export * from "./auth-jg.vue?vue&type=script&lang=js"
import style0 from "./auth-jg.vue?vue&type=style&index=0&id=5e9121ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9121ae",
  null
  
)

export default component.exports